<ion-header class="header --w-back-button --underline">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [defaultHref]="routes.home" text="" icon="arrow-back-outline"></ion-back-button>
    </ion-buttons>
    <ion-title>
      <span [innerHTML]="'Settings'"></span>
    </ion-title>
    <ion-buttons slot="end">
      <ion-menu-button class="header__burger" icon="menu-outline" autoHide="false"></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="settings --white">
  <span class="settings__title" [innerHTML]="'Account'"></span>
  <!-- ADVISE PLEASE DONT REMOVE THIS COMMENT, WE NEED THIS CODE -->
  <!-- <div class="settings__user" [routerLink]="[routes.profile]">
    <ion-avatar class="header__avatar">
      <img class="header__avatar__image" [src]="avatarImagePath" alt="{{ user.name + ' ' + user.lastName }}" />
    </ion-avatar>
    <div class="settings__user__content">
      <span class="settings__user__content__name" [innerHTML]="'Sabine'"></span>
      <span class="settings__user__content__mail" [innerHTML]="'sabine@gmail.com, Owner'"></span>
    </div>
    <ion-icon name="chevron-forward"></ion-icon>
  </div> -->
  <ion-button class="button --text --icon --icon-left" (click)="logout()">
    <ion-icon name="log-out-outline"></ion-icon>
    <span [innerHTML]="'Log out'"></span>
  </ion-button>
</ion-content>
